<template>
  <Transition
    enter-active-class="transition-opacity duration-300 ease-[cubic-bezier(0.25,0.8,0.5,1)]"
    enter-from-class="opacity-0"
    leave-active-class="transition-opacity duration-300 ease-[cubic-bezier(0.25,0.8,0.5,1)]"
    leave-to-class="opacity-0"
  >
    <slot />
  </Transition>
</template>
